<script setup>
import { formatCurrency } from '../helpers/format'

defineProps({ extras: { type: Array, default: () => [] } })
const model = defineModel({ type: Array, default: () => [] })
const selected = (extra) => model.value.some((item) => String(item.id) === String(extra.id))

const toggle = (extra) => {
  if (selected(extra)) {
    model.value = model.value.filter((item) => String(item.id) !== String(extra.id))
    return
  }
  model.value = [...model.value, {
    id: extra.id,
    name: extra.rezdyName ?? extra.name,
    displayName: extra.name,
    quantity: 1,
    price: Number(extra.price ?? 0),
  }]
}
</script>

<template>
  <div class="flex flex-col gap-4">
    <article
      v-for="extra in extras"
      :key="extra.id"
      class="flex flex-col gap-4 rounded-xl border bg-white p-4"
      :class="selected(extra) ? 'border-dark' : 'border-dark/20'"
    >
      <div class="flex items-start justify-between gap-4">
        <h3 class="text-lg font-semibold">{{ extra.name }}</h3>
        <span class="shrink-0 text-lg font-semibold">{{ formatCurrency(extra.price) }}</span>
      </div>
      <p v-if="extra.description" class="whitespace-pre-line text-mdx text-dark/70">{{ extra.description }}</p>
      <button
        type="button"
        class="button inline-flex items-center justify-center gap-2 cursor-pointer"
        :class="selected(extra) ? 'bg-light text-dark' : 'button-secondary'"
        :aria-pressed="selected(extra)"
        :aria-label="`${selected(extra) ? 'Remove' : 'Add'} ${extra.name}`"
        @click="toggle(extra)"
      >
        {{ selected(extra) ? 'Added — Remove extra' : extra.button || 'Add extra' }}
      </button>
    </article>
  </div>
</template>
